import React from 'react'

export const VibrantPinkInBlue = ({
  svgProps,
}: {
  hideGrain?: boolean
  svgProps: React.SVGProps<SVGSVGElement>
}) => {
  return (
    <svg
      {...svgProps}
      height="2026"
      viewBox="0 0 2719 2026"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5656_1016)">
        <g opacity="0.8" filter="url(#filter0_f_5656_1016)">
          <circle
            cx="1359.74"
            cy="1009.02"
            r="545.651"
            transform="rotate(91.6827 1359.74 1009.02)"
            fill="#176BE5"
          />
          <circle
            cx="1359.74"
            cy="1009.02"
            r="544.988"
            transform="rotate(91.6827 1359.74 1009.02)"
            stroke="#2F2F30"
            stroke-width="1.32477"
          />
        </g>
        <g opacity="0.9" filter="url(#filter1_f_5656_1016)">
          <ellipse
            cx="1099.91"
            cy="1040.7"
            rx="432.369"
            ry="371.694"
            transform="rotate(89.6652 1099.91 1040.7)"
            fill="#EF91F7"
          />
        </g>
        <g opacity="0.6" filter="url(#filter2_f_5656_1016)">
          <ellipse
            cx="1100.43"
            cy="921.677"
            rx="202.417"
            ry="213.553"
            transform="rotate(89.6652 1100.43 921.677)"
            fill="#FF824D"
          />
        </g>
        <g filter="url(#filter3_f_5656_1016)">
          <path
            d="M748.653 -213.043C796.121 -390.194 1109.59 -460.118 1448.81 -369.225C1788.03 -278.331 2024.54 -61.0385 1977.07 116.112C1929.61 293.263 1616.14 363.188 1276.92 272.295C937.697 181.401 701.186 -35.8924 748.653 -213.043Z"
            fill="#232323"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_5656_1016"
          x="414.089"
          y="63.3638"
          width="1891.31"
          height="1891.31"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="200"
            result="effect1_foregroundBlur_5656_1016"
          />
        </filter>
        <filter
          id="filter1_f_5656_1016"
          x="328.213"
          y="208.333"
          width="1543.39"
          height="1664.73"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="200"
            result="effect1_foregroundBlur_5656_1016"
          />
        </filter>
        <filter
          id="filter2_f_5656_1016"
          x="486.875"
          y="319.26"
          width="1227.11"
          height="1204.84"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="200"
            result="effect1_foregroundBlur_5656_1016"
          />
        </filter>
        <filter
          id="filter3_f_5656_1016"
          x="342.592"
          y="-809.058"
          width="2040.54"
          height="1521.19"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="200"
            result="effect1_foregroundBlur_5656_1016"
          />
        </filter>
        <clipPath id="clip0_5656_1016">
          <rect width="2719" height="2026" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
